var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-12 pb-0 px-0",attrs:{"id":"maingallery","fluid":"","tag":"section"}},[_c('headline',{attrs:{"gallery":_vm.gallery}}),_c('gallery',{attrs:{"path":_vm.path}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }